module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    attrs: {
      "withContent": true
    },
    on: {
      "close": _vm.cancel
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$trad.plano.renameFavoriteModal.title))]), _vm._v(" "), _c('main', [_c('TextInputBloc', {
    attrs: {
      "label": 'Nom',
      "min-length": 3,
      "required": true
    },
    model: {
      value: (_vm.label),
      callback: function($$v) {
        _vm.label = $$v
      },
      expression: "label"
    }
  })], 1), _vm._v(" "), _c('footer', [_c('ClientColorButton', {
    attrs: {
      "disabled": _vm.$v.label.$invalid
    },
    on: {
      "click": function($event) {
        _vm.validate();
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.ok))]), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "inactive-color": true
    },
    on: {
      "click": function($event) {
        _vm.cancel();
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.cancel))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79111f7f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/edits/rename_favorite.vue
// module id = 3281
// module chunks = 0